import { useMutation } from "@tanstack/react-query";
import {
  apiForgotPassword,
  apiForgotPasswordMailSend,
  apiRequestSignIn,
} from "./service";

export const useSignIn = () => {
  return useMutation({
    mutationFn: ({ params }: { params: any }) => apiRequestSignIn(params),
  });
};

export const useSendForgotPasswordMail = () => {
  return useMutation({
    mutationFn: ({ params }: { params: any }) =>
      apiForgotPasswordMailSend(params),
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: ({ params }: { params: any }) => apiForgotPassword(params),
  });
};
